import { createEvent, sample } from 'effector'
import { MenuItem } from 'react-aria-components'

import { cx } from '@portal/styled-system/css'

import { LogoutDialog } from '@/features/logout'
import { useI18n } from '@/shared/lib/i18n'

import { navbarMenu } from '../styles/recipe'

const logoutButtonClicked = createEvent<any>()

sample({
    clock: logoutButtonClicked,
    target: LogoutDialog.model.showFx,
})

export function LogoutButton() {
    const { i18n } = useI18n()
    const classes = navbarMenu()

    return (
        <MenuItem onAction={logoutButtonClicked} className={classes.item}>
            <i className={cx('fa-solid fa-right-from-bracket', classes.icon)} />
            &nbsp;{i18n.BUTTON_LOGOUT}
        </MenuItem>
    )
}
